/**
 * ScrollToTop.jsx — global route-change scroll reset.
 *
 * Without this, React Router preserves the previous page's scroll
 * position when a user navigates via <Link> or navigate() — so
 * tapping a drill tile from a scrolled-down Learn page lands the
 * user mid-page on the drill. Feb 14 2026 user report:
 * *"Drills and readings don't start from top page and user has to
 * scroll up to start. Fix that too"*.
 *
 * Mount ONCE inside <BrowserRouter>. Fires on every pathname change.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // `instant` prevents a jarring animated scroll on route change;
    // Safari older builds don't support smooth options so we pass
    // top+left too as a belt-and-braces fallback.
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
};

export default ScrollToTop;
